



































import Vue from 'vue'
export default Vue.extend({
    props: {
        //  Determines if the component is disabled
        disabled: {
            type: Boolean,
            default: false
        },
        //  The filter bound to the component
        filter: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            //  The width of the button content (so the component doesn't change size when content changes)
            width: '110px'
        }
    },
    mounted() {
        //  Set the buttons content width
        this.setWidth()
    },
    methods: {
        //  Gets the current font size of the menu button
        getFontSize(): number {
            //  Get the menu button
            const el = this.$refs.menuButton.$el

            //  Get the computed font size
            const size = window.getComputedStyle(el, null).getPropertyValue('font-size')

            // Convert string to integer
            const float = parseFloat(size)

            return float
        },
        //  Gets the pixel width of the longest filter option
        getPixelWidthOfText(text: string): number {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            context.font = this.getFontSize()
            const metrics = context.measureText(text)
            return Math.round(metrics.width)
        },
        onItemSelected(item: string): void {
            //  Set the selected filter
            this.filter.selected = item

            //  Emit the change event to the parent
            this.$emit('filterChanged', item)
        },
        //  Sets the button's content width (so changes to content don't change the size of the component)
        setWidth(): void {
            //  If the screen size is SmAndDown, use the default width
            if (this.$vuetify.breakpoint.smAndDown) return

            //  Find the option with the longest text (in pixels)
            const longestOption = this.filter.options.reduce((a, b) => {
                let aLength = this.getPixelWidthOfText(a.display)
                let bLength = this.getPixelWidthOfText(b.display)
                return aLength > bLength ? a : b
            })

            //  Get the pixel width of the longest option
            const pixels = this.getPixelWidthOfText(longestOption.display)

            //  Calcuate the menu width (28 is a generic value meant to provide padding to the button content)
            const width = 28 + pixels

            //  Real width is 200 if we are on a small screen and too big
            const realWidth = width > 120 && this.$vuetify.breakpoint.xsOnly ? 120 : width

            //  Set the button's content width (default to 200 if it is longer and on xs screens)
            this.width = `${realWidth}px`
        }
    }
})
